import { AccessTime, LocationOnOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const FORMATO_FECHA = {
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

// El backend serializa DateTime como "yyyy-MM-dd HH:mm:ss", que Safari no
// interpreta con new Date(); se normaliza a ISO antes de formatear.
const parseFecha = (valor) => {
  if (!valor) return null;
  const fecha = new Date(String(valor).replace(" ", "T"));
  return Number.isNaN(fecha.getTime()) ? null : fecha;
};

export const formatearVigencia = (inicio, fin) => {
  const desde = parseFecha(inicio);
  const hasta = parseFecha(fin);
  if (!desde || !hasta) return "Horario sin definir";
  const formatoHora = { hour: "2-digit", minute: "2-digit", hour12: false };
  const mismoDia = desde.toDateString() === hasta.toDateString();
  if (mismoDia) {
    return `${desde.toLocaleDateString("es-AR", { day: "2-digit", month: "short" })} · ${desde.toLocaleTimeString("es-AR", formatoHora)} a ${hasta.toLocaleTimeString("es-AR", formatoHora)}`;
  }
  return `${desde.toLocaleString("es-AR", FORMATO_FECHA)} a ${hasta.toLocaleString("es-AR", FORMATO_FECHA)}`;
};

export default function EventoHeaderInfo({ sede, inicio, fin, vendedor }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: { xs: 1, md: 2 },
        mt: 0.75,
        color: "rgba(255,255,255,.74)",
      }}
    >
      <Typography sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: 12 }}>
        <LocationOnOutlined sx={{ fontSize: 16 }} /> {sede || "Sede Villa Mercedes"}
      </Typography>
      <Typography sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: 12 }}>
        <AccessTime sx={{ fontSize: 16 }} /> {formatearVigencia(inicio, fin)}
      </Typography>
      <Typography sx={{ fontSize: 12 }}>Vendedor: {vendedor || "Sin identificar"}</Typography>
    </Box>
  );
}

EventoHeaderInfo.propTypes = {
  sede: PropTypes.string,
  inicio: PropTypes.string,
  fin: PropTypes.string,
  vendedor: PropTypes.string,
};
